/**
 * Aggregate splat `awardedCount` by `type` from Firestore `splatDefinitions` documents.
 * Groups by `String(data?.type ?? 'custom')` to match Splats list behavior.
 *
 * @param {Iterable<{ data: () => object }>} docSnapshots
 * @returns {{ totalSplatsAwarded: number, awardedByType: Array<{ type: string, awarded: number }> }}
 */
export function aggregateAwardedByTypeFromDocs(docSnapshots) {
  const byType = new Map();
  let totalSplatsAwarded = 0;

  for (const docSnap of docSnapshots) {
    const data = docSnap.data();
    const typeKey = String(data?.type ?? 'custom');
    const raw = Number(data?.awardedCount);
    let awarded = 0;
    if (Number.isFinite(raw) && raw >= 0) {
      awarded = raw;
    }
    totalSplatsAwarded += awarded;
    byType.set(typeKey, (byType.get(typeKey) || 0) + awarded);
  }

  const awardedByType = [...byType.entries()]
    .map(([type, awarded]) => ({ type, awarded }))
    .filter((row) => row.awarded > 0)
    .sort(
      (a, b) => b.awarded - a.awarded || a.type.localeCompare(b.type),
    );

  return { totalSplatsAwarded, awardedByType };
}
